export const RESULT_CLOUD_PATHS = {
  H_twh: "assets/result/H_twh.svg",
  H_ctw: "assets/result/H_ctw.svg",
  H_ctwh: "assets/result/H_ctwh.svg",
  H_h: "assets/result/H_h.svg",
  H_h_unisex: "assets/result/H_h_unisex.svg",
  H_c: "assets/result/H_c.svg",
  F_c: "assets/result/F_c.svg",
  F_cw: "assets/result/F_cw.svg",
  F_ctwh: "assets/result/F_ctwh.svg",
  F_wh: "assets/result/F_wh.svg",
  F_h_unisex: "assets/result/F_h_unisex.svg",
  example_tailes: "assets/result/example_tailes.png",
  example_tailes_2: "assets/result/example_tailes_2.png",
} as const;

export const SIZE_SELECTOR_CLOUD_PATHS = {
  H_twh: "assets/result/H_twh.svg",
  H_ctw: "assets/result/H_ctw.svg",
  H_ctwh: "assets/result/H_ctwh.svg",
  H_h: "assets/result/H_h.svg",
  H_h_unisex: "assets/result/H_h_unisex.svg",
  H_c: "assets/result/H_c.svg",
  F_c: "assets/result/F_c.svg",
  F_cw: "assets/result/F_cw.svg",
  F_ctwh: "assets/result/F_ctwh.svg",
  F_wh: "assets/result/F_wh.svg",
  F_h_unisex: "assets/result/F_h_unisex.svg",
} as const;

export const BELLY_CLOUD_PATHS = {
  // basic belly
  belly_1_female: "assets/questionnaire/belly/belly-1-female.svg",
  belly_2_female: "assets/questionnaire/belly/belly-2-female.svg",
  belly_3_female: "assets/questionnaire/belly/belly-3-female.svg",

  belly_1_male: "assets/questionnaire/belly/belly-1-male.svg",
  belly_2_male: "assets/questionnaire/belly/belly-2-male.svg",
  belly_3_male: "assets/questionnaire/belly/belly-3-male.svg",

  // victoria selected
  victoria_selected_1:
    "assets/questionnaire/belly/victoria-assets/selected/VB_SIZE&FIT_ILLUSTRATIONS-12.svg",
  victoria_selected_2:
    "assets/questionnaire/belly/victoria-assets/selected/VB_SIZE&FIT_ILLUSTRATIONS-13.svg",
  victoria_selected_3:
    "assets/questionnaire/belly/victoria-assets/selected/VB_SIZE&FIT_ILLUSTRATIONS-14.svg",

  // victoria unselected
  victoria_unselected_1:
    "assets/questionnaire/belly/victoria-assets/unselected/VB_SIZE&FIT_ILLUSTRATIONS-18.svg",
  victoria_unselected_2:
    "assets/questionnaire/belly/victoria-assets/unselected/VB_SIZE&FIT_ILLUSTRATIONS-19.svg",
  victoria_unselected_3:
    "assets/questionnaire/belly/victoria-assets/unselected/VB_SIZE&FIT_ILLUSTRATIONS-20.svg",

  // modern silhouette (female)
  modern_sillhouette_1: "assets/questionnaire/belly/modern/F-VENTRE_1.svg",
  modern_sillhouette_2: "assets/questionnaire/belly/modern/F-VENTRE_2.svg",
  modern_sillhouette_3: "assets/questionnaire/belly/modern/F-VENTRE_3.svg",

  // ogier modern female
  ogier_modern_1_female:
    "assets/questionnaire/belly/ogier/female/F-VENTRE_1.svg",
  ogier_modern_2_female:
    "assets/questionnaire/belly/ogier/female/F-VENTRE_2.svg",
  ogier_modern_3_female:
    "assets/questionnaire/belly/ogier/female/F-VENTRE_3.svg",

  // ogier modern male
  ogier_modern_1_male: "assets/questionnaire/belly/ogier/male/M-VENTRE_1.svg",
  ogier_modern_2_male: "assets/questionnaire/belly/ogier/male/M-VENTRE_2.svg",
  ogier_modern_3_male: "assets/questionnaire/belly/ogier/male/M-VENTRE_3.svg",

  // givenchy modern male selected
  givenchy_modern_1_male_selected:
    "assets/questionnaire/belly/givenchy/male/selected/M-VENTRE_1.svg",
  givenchy_modern_2_male_selected:
    "assets/questionnaire/belly/givenchy/male/selected/M-VENTRE_2.svg",
  givenchy_modern_3_male_selected:
    "assets/questionnaire/belly/givenchy/male/selected/M-VENTRE_3.svg",

  // givenchy modern male unselected
  givenchy_modern_1_male_unselected:
    "assets/questionnaire/belly/givenchy/male/unselected/M-VENTRE_1.svg",
  givenchy_modern_2_male_unselected:
    "assets/questionnaire/belly/givenchy/male/unselected/M-VENTRE_2.svg",
  givenchy_modern_3_male_unselected:
    "assets/questionnaire/belly/givenchy/male/unselected/M-VENTRE_3.svg",

  // givenchy modern female unselected
  givenchy_modern_1_female_unselected:
    "assets/questionnaire/belly/givenchy/female/unselected/F-VENTRE_1.svg",
  givenchy_modern_2_female_unselected:
    "assets/questionnaire/belly/givenchy/female/unselected/F-VENTRE_2.svg",
  givenchy_modern_3_female_unselected:
    "assets/questionnaire/belly/givenchy/female/unselected/F-VENTRE_3.svg",

  // givenchy modern female selected
  givenchy_modern_1_female_selected:
    "assets/questionnaire/belly/givenchy/female/selected/F-VENTRE_1.svg",
  givenchy_modern_2_female_selected:
    "assets/questionnaire/belly/givenchy/female/selected/F-VENTRE_2.svg",
  givenchy_modern_3_female_selected:
    "assets/questionnaire/belly/givenchy/female/selected/F-VENTRE_3.svg",
} as const;

export const CUISSES_CLOUD_PATHS = {
  // default male cuisses
  cuisses_1_male: "assets/questionnaire/сuisses/сuisses-1-male.svg",
  cuisses_2_male: "assets/questionnaire/сuisses/сuisses-2-male.svg",
  cuisses_3_male: "assets/questionnaire/сuisses/сuisses-3-male.svg",

  // ogier modern male
  ogier_modern_1_male: "assets/questionnaire/сuisses/ogier/M-CUISSE_1.svg",
  ogier_modern_2_male: "assets/questionnaire/сuisses/ogier/M-CUISSE_2.svg",
  ogier_modern_3_male: "assets/questionnaire/сuisses/ogier/M-CUISSE_3.svg",

  // givenchy male unselected
  givenchy_modern_1_male_unselected:
    "assets/questionnaire/сuisses/givenchy/unselected/M-CUISSE_1.svg",
  givenchy_modern_2_male_unselected:
    "assets/questionnaire/сuisses/givenchy/unselected/M-CUISSE_2.svg",
  givenchy_modern_3_male_unselected:
    "assets/questionnaire/сuisses/givenchy/unselected/M-CUISSE_3.svg",

  // givenchy male selected
  givenchy_modern_1_male_selected:
    "assets/questionnaire/сuisses/givenchy/selected/M-CUISSE_1.svg",
  givenchy_modern_2_male_selected:
    "assets/questionnaire/сuisses/givenchy/selected/M-CUISSE_2.svg",
  givenchy_modern_3_male_selected:
    "assets/questionnaire/сuisses/givenchy/selected/M-CUISSE_3.svg",
} as const;

export const SLEEVES_CLOUD_PATHS = {
  sleeve_1: "assets/questionnaire/sleeves/sleeve-1.svg",
  sleeve_2: "assets/questionnaire/sleeves/sleeve-2.svg",
} as const;

export const TORSO_CLOUD_PATHS = {
  // default female torse
  torse_1_female: "assets/questionnaire/torse/torse-1-female.svg",
  torse_2_female: "assets/questionnaire/torse/torse-2-female.svg",
  torse_3_female: "assets/questionnaire/torse/torse-3-female.svg",

  // default male torse
  torse_1_male: "assets/questionnaire/torse/torse-1-male.svg",
  torse_2_male: "assets/questionnaire/torse/torse-2-male.svg",
  torse_3_male: "assets/questionnaire/torse/torse-3-male.svg",

  // victoria selected
  victoria_selected_1:
    "assets/questionnaire/torse/victoria-assets/selected/VB_SIZE&FIT_ILLUSTRATIONS-15.svg",
  victoria_selected_2:
    "assets/questionnaire/torse/victoria-assets/selected/VB_SIZE&FIT_ILLUSTRATIONS-16.svg",
  victoria_selected_3:
    "assets/questionnaire/torse/victoria-assets/selected/VB_SIZE&FIT_ILLUSTRATIONS-17.svg",

  // victoria unselected
  victoria_unselected_1:
    "assets/questionnaire/torse/victoria-assets/unselected/VB_SIZE&FIT_ILLUSTRATIONS-21.svg",
  victoria_unselected_2:
    "assets/questionnaire/torse/victoria-assets/unselected/VB_SIZE&FIT_ILLUSTRATIONS-22.svg",
  victoria_unselected_3:
    "assets/questionnaire/torse/victoria-assets/unselected/VB_SIZE&FIT_ILLUSTRATIONS-23.svg",

  // modern silhouette (female)
  modern_sillhouette_1: "assets/questionnaire/torse/modern/F-HANCHE_1.svg",
  modern_sillhouette_2: "assets/questionnaire/torse/modern/F-HANCHE_2.svg",
  modern_sillhouette_3: "assets/questionnaire/torse/modern/F-HANCHE_3.svg",

  // ogier modern female
  ogier_modern_1_female:
    "assets/questionnaire/torse/ogier/female/F-HANCHE_1.svg",
  ogier_modern_2_female:
    "assets/questionnaire/torse/ogier/female/F-HANCHE_2.svg",
  ogier_modern_3_female:
    "assets/questionnaire/torse/ogier/female/F-HANCHE_3.svg",

  // ogier modern male
  ogier_modern_1_male: "assets/questionnaire/torse/ogier/male/M-TORSE_1.svg",
  ogier_modern_2_male: "assets/questionnaire/torse/ogier/male/M-TORSE_2.svg",
  ogier_modern_3_male: "assets/questionnaire/torse/ogier/male/M-TORSE_3.svg",

  // givenchy female selected
  givenchy_modern_1_female_selected:
    "assets/questionnaire/torse/givenchy/female/selected/F-HANCHE_1.svg",
  givenchy_modern_2_female_selected:
    "assets/questionnaire/torse/givenchy/female/selected/F-HANCHE_2.svg",
  givenchy_modern_3_female_selected:
    "assets/questionnaire/torse/givenchy/female/selected/F-HANCHE_3.svg",

  // givenchy female unselected
  givenchy_modern_1_female_unselected:
    "assets/questionnaire/torse/givenchy/female/unselected/F-HANCHE_1.svg",
  givenchy_modern_2_female_unselected:
    "assets/questionnaire/torse/givenchy/female/unselected/F-HANCHE_2.svg",
  givenchy_modern_3_female_unselected:
    "assets/questionnaire/torse/givenchy/female/unselected/F-HANCHE_3.svg",

  // givenchy male selected
  givenchy_modern_1_male_selected:
    "assets/questionnaire/torse/givenchy/male/selected/M-TORSE_1.svg",
  givenchy_modern_2_male_selected:
    "assets/questionnaire/torse/givenchy/male/selected/M-TORSE_2.svg",
  givenchy_modern_3_male_selected:
    "assets/questionnaire/torse/givenchy/male/selected/M-TORSE_3.svg",

  // givenchy male unselected
  givenchy_modern_1_male_unselected:
    "assets/questionnaire/torse/givenchy/male/unselected/M-TORSE_1.svg",
  givenchy_modern_2_male_unselected:
    "assets/questionnaire/torse/givenchy/male/unselected/M-TORSE_2.svg",
  givenchy_modern_3_male_unselected:
    "assets/questionnaire/torse/givenchy/male/unselected/M-TORSE_3.svg",
} as const;
